import inDOM from 'dom-helpers/canUseDOM'
import { NOT_FOUND } from 'redux-first-router'
import qs from 'query-string'
import { resolveInternalLinkUrl } from '../helpers/resolveLink'
import {
  getGlobalContent,
  getPageContent,
  isPreviewMode,
  isContentBusy,
  isContentError404
} from './slices/content'
import {
  isPreviewRoute,
  getCurrentRoutePath,
  isPageNotFound,
  getCurrentQueryString
} from './slices/location'
import {
  fetchGlobalContent,
  fetchPageContent,
  fetchPageNotFoundContent
} from './api'
import { routeContent, routeEmpty, redirectCreator } from './actions'

import { requestPreviewSession } from './slices/content/preview'
const contentThunk = async (dispatch, getState) => {
  const path = getCurrentRoutePath(getState())
  if (path.startsWith('/our-products/')) {
    // console.log('🛍️ Routes: Product page detected, checking for CMS content')
    // Always ensure global content is loaded for product pages
    if (!getGlobalContent(getState())) {
      await fetchGlobalContent(dispatch, getState)
    }

    // Try to fetch page content, but don't fail if it doesn't exist
    try {
      await fetchPageContent(dispatch, getState, path)
      // console.log('🛍️ Routes: Successfully loaded CMS content for product page')
    } catch (error) {
      if (error.status === 404) {
        // console.log('🛍️ Routes: No CMS page found for product, using product-only mode')
        // This is expected - not all products have dedicated CMS pages
        // The product page will still work with just the product data
      } else {
        console.error('🛍️ Routes: Error loading CMS content for product page:', error)
      }
    }
    return
  } const notFound = async () => {
    dispatch({ type: NOT_FOUND })
    return fetchPageNotFoundContent(dispatch, getState)
  }

  if (isPageNotFound(getState())) {
    return
  }

  const tasks = []
  if (!getGlobalContent(getState())) {
    tasks.push(fetchGlobalContent(dispatch, getState))
  }
  tasks.push(fetchPageContent(dispatch, getState, path))

  try {
    await Promise.all(tasks)
    if (isContentBusy(getState())) {
      // This should only happen when content arrived out of sequence (see: the race middleware).
      // Another request is already in progress, so don’t do anything further for this one.
      return
    }

    const content = getPageContent(getState())
    if (!content || !content.type || isContentError404(getState())) {
      await notFound()
    } else {
      const currentRoutePath = path
      const canonicalPath = resolveInternalLinkUrl(content)

      if (isPreviewMode(getState())) {
        if (!inDOM) {
          dispatch(requestPreviewSession())
        } else {
          // This will ensure any page refresh will still be in preview mode
          if (!isPreviewRoute(getState())) {
            window.history.replaceState(null, null, `/preview${path}`)
          }
        }
      } else {
        if (currentRoutePath !== canonicalPath) {
          const query = qs.stringify(getCurrentQueryString(getState()))
          dispatch(redirectCreator(getState(), canonicalPath + (query ? `?${query}` : '')))
        }
      }
    }
  } catch (error) {
    console.error(error)
    await notFound()
  }
}

export default {
  [routeContent.toString()]: {
    path: '*',
    toPath: segment => segment,
    thunk: contentThunk
  },
  [routeEmpty.toString()]: {
    path: '*',
    toPath: segment => segment
  }
}
